// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__HOmVR","disabled":"button_disabled__cxo0R"};